// @generated by protoc-gen-connect-web v0.6.0 with parameter "target=ts,ts_nocheck=false"
// @generated from file api/agent/svc_agent.proto (package com.diagnocat.agent.v1, syntax proto3)
/* eslint-disable */

import { ArchiveAgentThreadReq, ArchiveAgentThreadResp, CreateAgentThreadReq, CreateAgentThreadResp, GetAgentThreadReq, GetAgentThreadResp, ListAgentThreadsReq, ListAgentThreadsResp, RunAgentReq, RunAgentResp } from "./svc_agent_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service com.diagnocat.agent.v1.AgentService
 */
export const AgentService = {
  typeName: "com.diagnocat.agent.v1.AgentService",
  methods: {
    /**
     * @generated from rpc com.diagnocat.agent.v1.AgentService.ListThreads
     */
    listThreads: {
      name: "ListThreads",
      I: ListAgentThreadsReq,
      O: ListAgentThreadsResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.agent.v1.AgentService.GetThread
     */
    getThread: {
      name: "GetThread",
      I: GetAgentThreadReq,
      O: GetAgentThreadResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.agent.v1.AgentService.ArchiveThread
     */
    archiveThread: {
      name: "ArchiveThread",
      I: ArchiveAgentThreadReq,
      O: ArchiveAgentThreadResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.agent.v1.AgentService.CreateThread
     */
    createThread: {
      name: "CreateThread",
      I: CreateAgentThreadReq,
      O: CreateAgentThreadResp,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc com.diagnocat.agent.v1.AgentService.Run
     */
    run: {
      name: "Run",
      I: RunAgentReq,
      O: RunAgentResp,
      kind: MethodKind.ServerStreaming,
    },
  }
} as const;

